import FIInformation from "Constants/FIInformation";

export const Title = `${FIInformation.FI_APPLICATION_NAME} - ${FIInformation.FI_NAME}`;
export const SEOConfig = [
  {
    name: "description",
    content:
      "Since the bank received its charter in 1996, First Nations Bank of Canada, has grown to include 22 service points in five provinces and three territories with more than $1.2 billion in assets.",
  },
  {
    name: "robots",
    content: "index, follow",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
];
